const UploadImage = ({ onFileSelect }) => {
  const handleFileInput = (e) => {
    const file = e.target.files[0];
    onFileSelect(file);
  };

  return (
    <div className="feedback-inputs">
      <label htmlFor="image" className="feedback-label">
        Image
      </label>
      <input type="file" name="image" id="image" onChange={handleFileInput} />
    </div>
  );
};

export default UploadImage;
